import React from 'react';
import Modal from './Modal';

const ShareIcon = ({ className }) => (
  <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v12m0-12l-4 4m4-4l4 4" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 10H5a1 1 0 00-1 1v9a1 1 0 001 1h14a1 1 0 001-1v-9a1 1 0 00-1-1h-1" />
  </svg>
);

const AddBoxIcon = ({ className }) => (
  <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <path strokeLinecap="round" d="M12 9v6m-3-3h6" />
  </svg>
);

const IosInstallStep = ({ number, children }) => (
  <li className="flex items-start gap-3">
    <span className="flex-shrink-0 w-6 h-6 rounded-full bg-light_red text-primary text-[13px] font-semibold flex items-center justify-center">
      {number}
    </span>
    <span className="text-sm text-gray-700 pt-0.5">{children}</span>
  </li>
);

/**
 * iOS has no install API, so we walk the member through Safari's
 * "Add to Home Screen" flow. Shared by the floating install banner and the
 * Help page's "Get the app" card, so the instructions stay reachable even
 * after the banner has been dismissed.
 */
const PwaInstallInstructionsModal = ({ isOpen, onClose, onGotIt, isIosSafari }) => (
  <Modal
    name="pwa-install-ios"
    isOpen={isOpen}
    onClose={onClose}
    title="Add to your home screen"
  >
    <div className="normal-case tracking-normal">
      {!isIosSafari && (
        <p className="mb-4 text-[13px] text-gray-600 bg-light_red rounded-lg p-3">
          For the smoothest install, open this page in <span className="font-semibold">Safari</span> first.
        </p>
      )}
      <ol className="space-y-4">
        <IosInstallStep number={1}>
          Tap the <span className="font-semibold">Share</span> button
          <ShareIcon className="inline-block w-4 h-4 mx-1 -mt-0.5 text-primary" />
          in the toolbar at the bottom of your screen.
        </IosInstallStep>
        <IosInstallStep number={2}>
          Scroll down and tap <span className="font-semibold">Add to Home Screen</span>
          <AddBoxIcon className="inline-block w-4 h-4 mx-1 -mt-0.5 text-primary" />
        </IosInstallStep>
        <IosInstallStep number={3}>
          Tap <span className="font-semibold">Add</span> in the top corner — the Wildgrain app will appear on your home screen.
        </IosInstallStep>
      </ol>
      <button
        type="button"
        onClick={onGotIt || onClose}
        className="mt-5 w-full py-2.5 bg-primary hover:bg-primary-dark rounded-lg transition-colors"
      >
        Got it
      </button>
    </div>
  </Modal>
);

export default PwaInstallInstructionsModal;
